<h6>List Of Registered Users</h6>


<!-----

<p *ngIf="!users"><b>Loading.....</b></p>
<table class="table table-stripped table-condensed " *ngIf="users">
  <thead>
    <tr>
      <th>Email Id</th>
      <th>Program Applied</th>
      <th>Full Name</th>
      <th>Contact No</th>
      <th>Education</th>
      <th>Date Of Birth</th>
      <th>P Language</th>
      <th>Gender</th>
      <th>Complaint</th>
      <th>Previous Course</th>
      <th>City</th>
      <th>TimeZone</th>
      <th>Date Of Joining</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let user of users">
      <td>{{user.email}}</td>
      <td>{{user.pAppliedFor}}</td>
      <td>{{user.fullName}}</td>
      <td>{{user.contactNo}}</td>
      <td>{{user.education}}</td>
      <td>{{user.dateOfBirth  | date: "dd/MM/yyyy" }}</td>
      <td>{{user.pLanguage}}</td>
      <td>{{user.gender}}</td>
      <td>{{user.complaint}}</td>
      <td>{{user.pCourse}}</td>
      <td>{{user.city}}</td>
      <td>{{user.timeZone}}</td>
      <td>{{user.dateJoin | date: "dd/MM/yyyy"}}</td>
    </tr>
  </tbody>

</table>



-->
